import type {
  LhcFilter,
  LhcItemsFilter,
  SelectOption,
} from '@diamond/shared/types';

export interface LHCListFilterState {
  page: number;
  size: number;
  dateFrom: string;
  dateTo: string;
  plantValue: SelectOption | null;
  cabangValue: SelectOption | null;
  searchQuery: string;
}

export function buildLhcFilter(state: LHCListFilterState): LhcFilter {
  const params: LhcFilter = { page: state.page, size: state.size };
  if (state.dateFrom) {
    params.start_date = Math.floor(new Date(state.dateFrom).getTime() / 1000);
  }
  if (state.dateTo) {
    params.end_date = Math.floor(new Date(state.dateTo).getTime() / 1000);
  }
  const plantId = state.plantValue?.value;
  if (plantId && plantId !== 'all' && plantId !== '') {
    params.collection_plant_id = plantId;
  }
  if (state.cabangValue?.value) {
    params.distribution_channel = state.cabangValue.value;
  }
  if (state.searchQuery) {
    params.search_by = 'lhc_no';
    params.search_query = state.searchQuery;
  }
  return params;
}

export interface LHCItemsFilterState {
  dateFrom: string;
  dateTo: string;
  plantFilter: SelectOption | null;
  appliedSearch: string;
}

export function buildLhcItemsFilter(
  state: LHCItemsFilterState
): LhcItemsFilter {
  const params: LhcItemsFilter = {};
  if (state.dateFrom) {
    params.start_date = Math.floor(new Date(state.dateFrom).getTime() / 1000);
  }
  if (state.dateTo) {
    params.end_date = Math.floor(new Date(state.dateTo).getTime() / 1000);
  }
  const plantId = state.plantFilter?.value;
  if (plantId && plantId !== 'all' && plantId !== '') {
    params.collection_plant_id = plantId;
  }
  if (state.appliedSearch) {
    params.search_query = state.appliedSearch;
  }
  return params;
}
